<template>
    <div
        :class="{
            'premium-yield': true,
            'padded-page': true,
            none: reviewData?.total_pyi <= 0,
        }"
        ref="screenWrapper"
    >
        <template v-if="reviewData?.total_pyi > 0">
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg">You Invested a total of</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.total_pyi ?? 0" currency="₦" />
                </p>
                <p>in Premium Yield Investment in 2025.</p>
            </div>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg">Sycamore paid you</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.pyi_returns ?? 0" currency="₦" />
                </p>
                <p>in Investment returns.</p>
            </div>
        </template>
        <template v-else>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg mb-4">Ready to grow your money tree?</p>
                <p class="text-lg">Earn up to</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">27.5%</p>
                <p>interest when you invest in PYI, and watch your money do the talking. Invest today!</p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.premium-yield {
    color: #fcfcde;
    background-color: #009951;
    background-image: url("../../assets/images/year-in-review/premium-yield.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom right;
    min-height: 100vh;
}

.premium-yield.none {
    background-image: url("../../assets/images/year-in-review/premium-yield-none.svg");
}

@media (max-height: 750px) {
    .premium-yield {
        background-size: 85% auto;
    }
}
</style>
